<template>
  <input type="text" inputmode="decimal" :value="displayValue"
    @input="onInput" @compositionend="onInput" />
</template>

<script>
import { nextTick } from 'vue';
import { canonicalNumberInput, groupedNumberInput, groupedCaretPosition } from './groupedNumber.mjs';

export default {
  name: 'GroupedNumberInput',
  props: { modelValue: { type: [String, Number], default: '' } },
  emits: ['update:modelValue'],
  computed: {
    displayValue() { return groupedNumberInput(this.modelValue); },
  },
  methods: {
    onInput(event) {
      if (event.isComposing) return;
      const input = event.target;
      const meaningful = input.value.slice(0, input.selectionStart ?? input.value.length).replace(/\s/g, '').length;
      const canonical = canonicalNumberInput(input.value);
      const formatted = groupedNumberInput(canonical);
      input.value = formatted;
      this.$emit('update:modelValue', canonical);
      nextTick(() => {
        if (document.activeElement === input) {
          const position = groupedCaretPosition(formatted, meaningful);
          input.setSelectionRange(position, position);
        }
      });
    },
  },
};
</script>

<style scoped>
input { font-variant-numeric: tabular-nums; letter-spacing: .02em; }
</style>
